export default __webpack_public_path__ + "static/media/resp-gaming.dc8c416f.svg";